import dayjs from 'dayjs';

export const formatRelative = (iso: string): string => dayjs(iso).fromNow();

export const formatClock = (iso: string): string => dayjs(iso).format('HH:mm');

export const formatDateTime = (iso: string): string => dayjs(iso).format('D MMM, HH:mm');

export const formatDate = (iso: string): string => dayjs(iso).format('D MMM YYYY');

export const formatDayShort = (key: string, reference: string): string =>
    (key.slice(0, 4) === reference.slice(0, 4) ? dayjs(key).format('D MMM') : dayjs(key).format('D MMM YYYY'));

export const formatDuration = (ms: number): string => {
    if (ms < 1000) return `${ms} ms`;
    if (ms < 60_000) return `${Math.round(ms / 1000)} s`;
    if (ms < 3_600_000) return `${Math.round(ms / 60_000)} min`;
    if (ms < 86_400_000) return `${Math.round(ms / 3_600_000)} h`;
    return `${Math.round(ms / 86_400_000)} g`;
};

export const formatRemaining = (iso: string): string => {
    const diff = dayjs(iso).diff(dayjs());
    if (diff <= 0) return 'scaduto';
    return formatDuration(diff);
};
